import { render, staticRenderFns } from "./lists_dropdown.vue?vue&type=template&id=87c6b396&"
import script from "./lists_dropdown.vue?vue&type=script&lang=js&"
export * from "./lists_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports